// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-125629d1]{fill:var(--v-primary-base)}.cls-2[data-v-125629d1]{fill:#febf7c}.cls-3[data-v-125629d1]{fill:#fff3e7}.cls-4[data-v-125629d1]{fill:#eee3d8}.cls-5[data-v-125629d1]{fill:#fcd8b1}.cls-6[data-v-125629d1]{-webkit-filter:url(#Pfad_501);filter:url(#Pfad_501)}.cls-7[data-v-125629d1]{-webkit-filter:url(#Pfad_491);filter:url(#Pfad_491)}", ""]);
// Exports
module.exports = exports;
